import { render } from "./GeneralJournal.vue?vue&type=template&id=53b96d5a&scoped=true&ts=true"
import script from "./GeneralJournal.vue?vue&type=script&lang=ts"
export * from "./GeneralJournal.vue?vue&type=script&lang=ts"

import "./GeneralJournal.vue?vue&type=style&index=0&id=53b96d5a&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b96d5a"]])

export default __exports__